

const DepthAndRogWeightages = (demandForecastType) => {
  if (demandForecastType == "99% depth") {
    return { ROG: 0.01, depth: 0.99 }
  } else if (demandForecastType == "Actual") {
    return { ROG: 0, depth: 1 }
  }
  if (!isNaN(parseFloat(demandForecastType))) {
    const depthShare = parseFloat(demandForecastType)
    return { ROG: 1 - depthShare, depth: depthShare }
  }
  return { ROG: 0, depth: 1 }
}


export default DepthAndRogWeightages
